import React, {useEffect, useState} from 'react';
import AttackInspector from "../../../../../components/customBreachBits/inspectors/AttackInspector";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {setCustomerInView} from "../../../../../actions";
import ModuleNotAvailableModal from "../../../../../components/customBreachBits/modals/ModuleNotAvailableModal";

const Inspector = (props) => {

  //variables grabbed form the URL parameters or the url bar.  ? params take precedence?
  const {match} = props;
    let urlAttackId = match.params.attackId
            ? match.params.attackId
            : null;
    const urlCustomerId = match.params.customerId
            ? match.params.customerId
            : null;

  //if the profileId was passed in the URL, grab it and set it as initial state

    // const location = useLocation()
    let history = useHistory()

    const {customerInView, customers} = useSelector(({customer}) => customer);
    const dispatch = useDispatch();

    const [recentCustomerInView, setRecentCustomerInView] = useState(customerInView ? customerInView : null);
    const [recentAttackInView, setRecentAttackInView] = useState(urlAttackId ? urlAttackId : null);

    useEffect(() => {
        // alert(match.params.customerId);
        // alert(urlCustomerId);
        //switch to the given customer
        if(customers && urlCustomerId) {
            //check to see if that customer is in store
            const customerIdsAvailable = Object.keys(customers);
            // alert("checking");
            if(urlCustomerId === recentCustomerInView && urlAttackId === recentAttackInView && customerInView !== urlCustomerId) {
                urlAttackId = null;
                history.push(`/board/CIRT/inspector`);
                // alert("urlCustomerId === recentCustomerInView && urlAttackId === recentAttackInView && customerInView !== urlCustomerId");
            } else if(customerIdsAvailable.includes(urlCustomerId)) {
                dispatch(setCustomerInView(urlCustomerId));
                // alert("not urlCustomerId === recentCustomerInView && urlAttackId === recentAttackInView && customerInView !== urlCustomerId");
            }
        }

        //clear out any passed url parameters
        // if(customers && customerInView === urlCustomerId && (urlAttackId || urlCustomerId)) {
        //     const queryParams = new URLSearchParams(location.search);
        //     queryParams.delete('attack')
        //     queryParams.delete('cid')
        //     history.replace({
        //         search: queryParams.toString(),
        //     })
        // }

        setRecentCustomerInView(customerInView);
        setRecentAttackInView(urlAttackId);
    }, [dispatch, urlCustomerId, urlAttackId, customers, customerInView]);

    const onChangeAttack = (attackId) => {
        // alert("changed row")
        history.push(`/board/CIRT/inspector/${customerInView}/attack/${attackId}`)
    }
    //check to see if the customerInView has changed, perhaps from the user clicking the multi menu bar
    // let isNewCustomer = false;
    // if(customerInView !== recentCustomerInView && urlAttackId !== recentAttackInView) {
        //customer may have changed. If the attack is the same... then its a customer change and not a new paste?
        // isNewCustomer = true;
        // history.push(`/board/CIRT/inspector/${customerInView}`)
    // }

    const updateInspectorUrlState = () => {
        return urlAttackId
    }

  return (
    <div className="app-wrapper animated fadeIn animation-duration-7">
        {!!customerInView && <ModuleNotAvailableModal moduleId={2}/>}
      {/*<ContainerHeader title={<IntlMessages id="pages.attackInspector"/>} match={props.match}/>*/}
      <AttackInspector
          defaultAttackId = {updateInspectorUrlState()}
          customerId = {customerInView}
          onChangeAttack = {onChangeAttack}
      />
    </div>
  );
};

export default Inspector;

